export const arrayReplace = (array, index, item) => {
    return [...array.slice(0, index), item, ...array.slice(index + 1)];
};

export const arrayRemove = (array, index) => {
    return [...array.slice(0, index), ...array.slice(index + 1)];
};

export const arrayAppend = (array, item) => {
    return [...array, item];
};

export const arrayPrepend = (array, item) => {
    return [item, ...array];
};

export const arrayAny = (array, compare) => {
    return array.find(compare) !== undefined;
};

export const arrayUniqBy = (array, prop) => {
    const onlyOne = {};
    return array.filter(item => {
        if (onlyOne[item[prop]])
            return false;
        onlyOne[item[prop]] = true;
        return true;
    });
};